import { useEffect } from 'react';
import {
  ProjectPrivacyTemplate,
  ProjectSupportTemplate,
  ProjectTermsTemplate,
} from '../components/templates';
import { apresNoteContent } from '../data/projectContent';
import type { Project } from '../data/projects';
import type { ProjectNavigation } from '../components/templates/projectNavigation';

type Page = 'privacy' | 'terms' | 'support';

const project: Pick<Project, 'name' | 'slug' | 'links'> = {
  name: 'ApresNote',
  slug: 'apresnote',
  links: [
    { type: 'docs', label: 'Manage Apple subscriptions', url: 'https://support.apple.com/en-us/118428' },
    { type: 'docs', label: 'Request an Apple refund', url: 'https://support.apple.com/en-us/118223' },
  ],
};

const navigation: ProjectNavigation = {
  home: { path: '/projects', label: 'Apres AI Projects' },
  basePath: '/apresnote',
  termsPath: '/apresnote/terms',
};

export default function ApresNotePage({ page }: { page: Page }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = apresNoteContent[page].title;
    return () => { document.title = previousTitle; };
  }, [page]);

  const props = { project, navigation };
  switch (page) {
    case 'privacy':
      return <ProjectPrivacyTemplate {...props} content={apresNoteContent.privacy} />;
    case 'terms':
      return <ProjectTermsTemplate {...props} content={apresNoteContent.terms} />;
    case 'support':
      return <ProjectSupportTemplate {...props} content={apresNoteContent.support} />;
  }
}
